import { render, staticRenderFns } from "./commodityFlowStateInitComponent.vue?vue&type=template&id=373429a1&scoped=true&"
import script from "./commodityFlowStateInitComponent.vue?vue&type=script&lang=js&"
export * from "./commodityFlowStateInitComponent.vue?vue&type=script&lang=js&"
import style0 from "./commodityFlowStateInitComponent.vue?vue&type=style&index=0&id=373429a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373429a1",
  null
  
)

export default component.exports